import type { ContentReport } from '@pulsify/shared'
import { api, unwrap } from '~/shared/lib/rpc'

export type ContentReportStatus = ContentReport['status']

export const contentReportsApi = {
  async list(status: ContentReportStatus): Promise<ContentReport[]> {
    const res = await api.api['content-reports'].$get({ query: { status } })
    const body = await unwrap<{ reports: ContentReport[] }>(res)
    return body.reports
  },

  async resolve(id: string): Promise<void> {
    await unwrap(await api.api['content-reports'][':id'].resolve.$patch({ param: { id } }))
  },

  async remove(id: string): Promise<void> {
    await unwrap(await api.api['content-reports'][':id'].$delete({ param: { id } }))
  },
}
